import TextField from '@/components/skeletons/TextField'
import { useQueryWithHandler } from '@/hooks/useQueryWithHandler'
import { getAllDepartments } from '@/modules/Employee/services'
import { Department } from '@/modules/Employee/types/response'
import { useTranslation } from 'react-i18next'

import { QUERY_KEYS } from '@/constants/reactQueryKeys'

interface DepartmentsProps {
    departments?: number[]
}
const Departments = ({ departments }: DepartmentsProps) => {
    const { t } = useTranslation()
    const { data, renderState } = useQueryWithHandler({
        queryKey: [QUERY_KEYS.DEPARTMENTS],
        queryFn: () => getAllDepartments(),
        loadingComponent: <TextField />,
    })

    const stateComponent = renderState()
    if (stateComponent) return stateComponent

    const departmentSelected = data?.results.filter((department: Department) =>
        departments?.includes(department.department_id)
    )
    return (
        <div className="flex items-center gap-2 flex-wrap">
            {departmentSelected?.map((department: Department) => (
                <div
                    key={department.department_id}
                    className="px-4 py-2 bg-secondary-20 text-primary-80 rounded-sm text-sm font-medium capitalize"
                >
                    {t('department')}{' '}
                    {department.department_name?.toLowerCase()}
                </div>
            ))}
        </div>
    )
}

export default Departments
